import React from 'react'
import Arrow from '../../assets/images/arrow.svg'

export default function Notification() {
    return (
        <section class="Notifications-wrapper">
      <div class="container">
        <div class="Notifications">
          <div class="row no-gutters">
            <div class="col-md-8 col-sm-12 col-12 padding-rt">
              <div class="generate">
               <h3>
                 {/* <img class="mr-2" src={Arrow} /> */}
                Report issue</h3>
              <div class="card-wrapper">
                <div class="card-info">
                    <div class="media">
                        <div class="media-body"> 
                        <p>It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum </p>
                        </div>
                      </div>
                </div>
            </div>
            <div class="card-wrapper">
                <div class="card-info">
                    <div class="media">
                        <div class="media-body"> 
                          <p>It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum </p>
                        </div>
                      </div>
                </div>
            </div>
            <div class="card-wrapper">
                <div class="card-info">
                    <div class="media">
                        <div class="media-body"> 
                          <p>It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum </p>
                        </div>
                      </div>
                </div>
            </div>
            <div class="card-wrapper">
                <div class="card-info">
                    <div class="media">
                        <div class="media-body"> 
                          <p>It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum </p>
                        </div>
                      </div>
                </div>
            </div>
              
             </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    )
}
